import { useEffect, useRef, useState } from 'react';

export const useResultAnimation = (target, sequence, enabled, startValue = 1, duration = 850) => {
  const [animation, setAnimation] = useState({ sequence, value: target, running: false });
  const enabledRef = useRef(enabled), previous = useRef(target), durationRef = useRef(duration);
  enabledRef.current = enabled; durationRef.current = duration;
  useEffect(() => {
    const from = startValue === null ? previous.current : startValue;
    previous.current = target;
    if (!sequence || !enabledRef.current || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { setAnimation({ sequence, value: target, running: false }); return; }
    let frame;
    const started = performance.now();
    setAnimation({ sequence, value: from, running: true });
    const tick = (time) => {
      const progress = Math.min(1, (time - started) / durationRef.current);
      setAnimation({ sequence, value: progress < 1 ? from + (target - from) * (1 - (1 - progress) ** 3) : target, running: progress < 1 });
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, sequence, startValue]);
  // Treat a new result as pending on its very first render, before the effect
  // starts, so neither its color nor its history chip can flash ahead of it.
  if (animation.sequence !== sequence) {
    const pending = !!sequence && enabled && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    return [pending ? (startValue === null ? previous.current : startValue) : target, pending];
  }
  return [animation.value, animation.running];
};